import { COLOR_GREEN, COLOR_GREY_3 } from "shared/theme/colors";
import { FaqGroupStatus } from "./types";

export const FAG_GROUP_STATUS_LABELS: Record<FaqGroupStatus, string> = {
  [FaqGroupStatus.Active]: "Active",
  [FaqGroupStatus.Draft]: "Draft",
};

export const FAG_GROUP_STATUS_COLORS: Record<FaqGroupStatus, string> = {
  [FaqGroupStatus.Active]: COLOR_GREEN,
  [FaqGroupStatus.Draft]: COLOR_GREY_3,
};
